import GiphyViewer from './giphy-viewer';
import { GIPHY_TYPE } from './constants';
export var typeMapper = function () {
    var _a;
    return (_a = {},
        _a[GIPHY_TYPE] = { component: GiphyViewer },
        _a);
};
//# sourceMappingURL=typeMapper.js.map